angular.module("vgresiduos").controller("IndicationRequestEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `mercado/solicitacao/${$stateParams.id}`);
		};
	}
]);
